import React from 'react';
import Link from '@mui/material/Link';
import CardItem from 'components/CardItem';
import Card from 'components/Card';
import {
  EditAction,
  ModelCardColumn,
  ModelCardContainer,
  ModelCardContent,
  ModelName,
} from './styles';

export default function CardModels(props) {
  return (
    <ModelCardContainer>
      <ModelCardColumn>
        <Card
          bordered
          style={{
            marginTop: '10px',
          }}
        >
          <ModelCardContent>
            <ModelName>
              <CardItem className="nameClients" style={{ margin: '15px 0px' }}>
                {props.models.name}
              </CardItem>
            </ModelName>
            <EditAction>
              <Link
                style={{
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  margin: '15px 0px',
                  cursor: 'pointer',
                }}
                onClick={() => props.handleOpened(props.models)}
              >
                Editar <i className="fas fa-chevron-right" />
              </Link>
            </EditAction>
          </ModelCardContent>
        </Card>
      </ModelCardColumn>
    </ModelCardContainer>
  );
}
